import React from 'react';
import TextBox from '../Basic/TextBox';

const PasswordBox = (p) => {
    return (
        <TextBox {...p} isPassword={true} isShowPassword={true}  hideEye={true} />
    );
};

export default PasswordBox;